// @ts-nocheck

export default {
  send: function (event_name, category, action, label, value: any = null) {
    try {
      window.dataLayer = window.dataLayer || [];

      const dataLayerObj = {
        event: 'ga_' + event_name,
        event_category: category,
        event_action: action,
        event_label: label,
      };

      if (value !== null) {
        dataLayerObj.value = value;
      }

      window.dataLayer.push(dataLayerObj);
    } catch (error) {
      console.error('Failed to push GA event to dataLayer:', error);
    }
  },
};
